// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/theme/index.css'

import router from './router'
import store from './store/index'



import VueCropper from 'vue-cropper' 
import 'babel-polyfill'


Vue.use(VueCropper)
Vue.use(ElementUI);



Vue.config.productionTip = false


// 图形验证码
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);



//md5加密
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
//接口路径配置
import globalPath from '@/assets/script/globalPath.vue' 
Vue.prototype.API = globalPath.globalPath //接口路径配置

//全局方法
import common from './assets/script/common.js'
Vue.prototype.$common = common

window.Vue = new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js